import MainLayout from "../components/CommonComponents/MainLayout";
import CustomerTable from "./CustomerTable";

export default function CustomerManagementPage() {
  return (
    <MainLayout>
      <div className="pt-6">
        <CustomerTable />
      </div>
    </MainLayout>
  );
}
